module.exports = __webpack_public_path__ + "static/media/Icon feather-edit.1226e8fa.svg";